var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var LoadingOverlay = function (_a) {
    var loadingText = _a.loadingText, _b = _a.textStyles, textStyles = _b === void 0 ? "text-center" : _b;
    return (_jsxs("div", __assign({ className: "h-full fill-gray-500 text-gray-500 w-full bg-slate-300 bg-opacity-50 flex flex-col justify-center content-center gap-2 p-3 items-center" }, { children: [_jsx("svg", __assign({ className: "h-6 w-6 animate-spin", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 25" }, { children: _jsx("path", { d: "M8,8.5A3.5,3.5,0,1,1,4.5,5,3.5,3.5,0,0,1,8,8.5ZM4.5,14A3.5,3.5,0,1,0,8,17.5,3.5,3.5,0,0,0,4.5,14Zm16-2A3.5,3.5,0,1,0,17,8.5,3.5,3.5,0,0,0,20.5,12Zm0,2A3.5,3.5,0,1,0,24,17.5,3.5,3.5,0,0,0,20.5,14Zm-8,4A3.5,3.5,0,1,0,16,21.5,3.5,3.5,0,0,0,12.5,18Zm0-18A3.5,3.5,0,1,0,16,3.5,3.5,3.5,0,0,0,12.5,0Z" }) })), loadingText && _jsx("span", __assign({ className: textStyles }, { children: loadingText }))] })));
};
